// #ux-redesign-start: toggle de tema en AdminNavbar (Paso 1)
// Toggle binario Light ↔ Dark. El modo "System" se removió por feedback del
// usuario (2026-05-17): "deberia ser normaria — o es dark o es light".
//
// PORTABILIDAD: trasplantable a Web-Patients (depende solo de ThemeContext + reactstrap).
// ─────────────────────────────────────────────────────────────────────────────

import React, { useState } from 'react';
import { useTheme } from 'contexts/ThemeContext';
import { Tooltip } from 'reactstrap';

const LABEL = {
  light: 'Hell',
  dark: 'Dunkel',
};

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const isDark = theme === 'dark';
  const next = isDark ? 'light' : 'dark';
  const toggle = () => setTheme(next);

  return (
    <li className="nav-item" style={{ display: 'flex', alignItems: 'center' }}>
      <button
        id="ux-theme-toggle"
        type="button"
        onClick={toggle}
        aria-label={`Aktuelles Thema: ${LABEL[theme]}. Klicken um zu wechseln.`}
        className="ux-theme-toggle"
      >
        {isDark ? (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
          </svg>
        )}
      </button>
      <Tooltip
        placement="bottom"
        isOpen={tooltipOpen}
        target="ux-theme-toggle"
        toggle={() => setTooltipOpen(!tooltipOpen)}
      >
        {LABEL[theme]} → {LABEL[next]}
      </Tooltip>
    </li>
  );
};

export default ThemeToggle;
// #ux-redesign-end
